import {
  SENSITIVE_DATA_DEFAULT_SECTION_TITLE,
  SENSITIVE_DATA_SECTION_TITLE_BY_ID,
  SENSITIVE_DATA_SECTION_TITLE_BY_TYPE,
} from "constants/sensitiveData";

export const getSensitiveDataSectionTitle = (
  sensitiveDataTypeId?: string,
  sensitiveDataType?: string
): string =>
  SENSITIVE_DATA_SECTION_TITLE_BY_ID[sensitiveDataTypeId || ""] ||
  SENSITIVE_DATA_SECTION_TITLE_BY_TYPE[sensitiveDataType || ""] ||
  SENSITIVE_DATA_DEFAULT_SECTION_TITLE;
